var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBtnRemoveSurvey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 36,
    viewBox: "0 0 48 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4 25L17 23.6L22.6 18L17 12.4L18.4 11L24 16.6L29.6 11L31 12.4L25.4 18L31 23.6L29.6 25L24 19.4L18.4 25Z",
    fill: "#65142C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnRemoveSurvey);
export default __webpack_public_path__ + "static/media/btn-remove-survey.de326eecc41e1883ae879a6250bd44de.svg";
export { ForwardRef as ReactComponent };